module.exports = __webpack_public_path__ + "media/הר.1726c3ee.mp3";